import type { PublicSlotKey } from '@/apilib';
import type { FixedStageApi } from './api';

export const FixedStageApiKey: PublicSlotKey<FixedStageApi> = {
  name: 'FixedStageApi',
  public: true,
};
